import { environment } from 'src/environments/environment';

export class BaseUrl {
  BASE_URL: string = environment.BASE_URL;
  VAS_SOCKET_URL: string = environment.VAS_SOCKET_URL;
  constructor() {}
}
